import type { ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

interface IconTooltipProps {
  label: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  children: ReactNode;
}

/**
 * Single source of truth for icon-button tooltips. The global
 * `TooltipProvider` mounted in main.tsx supplies the 300ms delay that
 * matches the cog-icon reference in workspace-settings-menu.tsx.
 *
 * Usage:
 *   <IconTooltip label="Settings">
 *     <button aria-label="Settings"><GearSix /></button>
 *   </IconTooltip>
 *
 * Do not wrap DropdownMenuTrigger — dropdown triggers use aria-label only
 * (see workspace-settings-menu.tsx). In Electron, add
 * `[-webkit-app-region:no-drag]` on header action triggers.
 */
export function IconTooltip({
  label,
  side = "top",
  children,
}: IconTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} className="flex items-center gap-1.5">
        <span>{label}</span>
      </TooltipContent>
    </Tooltip>
  );
}
